import PropTypes from "prop-types";

const LoadingIcon = (props) => {
  return <img {...props} src={process.env.PUBLIC_URL + "/images/Loading-Icon.gif"} alt="Loading..." style={props.sx} />;
};

LoadingIcon.propTypes = {
  sx: PropTypes.object,
};

export default LoadingIcon;
